import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	constructor(private toastr: ToastrService) {}

	open(
		type: 'success' | 'error' | 'info' | 'warning',
		title: string,
		message: string,
		duration: number = 3000,
		position?: 'left' | 'center' | 'right',
	) {
		const toastrOptions: any = {
			timeOut: duration,
			positionClass: position ? `toast-bottom-${position}` : 'toast-bottom-right',
		};

		let toast: ActiveToast<any>;
		switch (type) {
			case 'success':
				toastrOptions.toastClass = 'success';
				toast = this.toastr.success(message, title, toastrOptions);
				break;
			case 'error':
				toastrOptions.toastClass = 'error';
				toast = this.toastr.error(message, title, toastrOptions);
				break;
			case 'info':
				toastrOptions.toastClass = 'info';
				toast = this.toastr.info(message, title, toastrOptions);
				break;
			case 'warning':
				toastrOptions.toastClass = 'warning';
				toast = this.toastr.warning(message, title, toastrOptions);
				break;
			default:
				console.warn('Invalid toast type');
		}

		if (toastrOptions.timeOut) {
			setTimeout(() => {
				this.toastr.remove(toast.toastId);
			}, toastrOptions.timeOut);
		}
	}
}
